import { BaseElementWithoutShadowDOM } from '@theme/base-element'

export class DeferredMedia extends BaseElementWithoutShadowDOM {
  static get properties() {
    return {
      playing: { reflect: true, attribute: 'playing' },
      muted: { reflect: true, attribute: 'muted' },
    }
  }

  get video() {
    return this.updateComplete.then(
      () => this.renderRoot?.querySelector('video') ?? null
    )
  }
  get playToggle() {
    return this.updateComplete.then(
      () => this.renderRoot?.querySelector('[play-toggle]') ?? null
    )
  }
  get volumeToggle() {
    return this.updateComplete.then(
      () => this.renderRoot?.querySelector('[volume-toggle]') ?? null
    )
  }

  constructor() {
    super()

    this.playing = false
    this.muted = true
    this._handlePlayState = this._handlePlayState.bind(this)
    this._handleVolumeToggle = this._handleVolumeToggle.bind(this)
  }

  async connectedCallback() {
    super.connectedCallback()
    const playToggle = await this.playToggle
    playToggle?.addEventListener('click', this._handlePlayState)

    const volumeToggle = await this.volumeToggle
    volumeToggle?.addEventListener('click', this._handleVolumeToggle)

    this._attachHTMLVideoEvents()
  }

  play() {
    if (this.playing) return
    this.#play()
  }

  pause() {
    if (!this.playing) return
    this.#pause()
  }

  mute() {
    this.video.then(($video) => {
      $video.muted = true
      this.muted = true
    })
  }

  _handlePlayState(event) {
    event.preventDefault()
    this.playing ? this.pause() : this.play()
  }

  _handleVolumeToggle(event) {
    event.preventDefault()
    this.video.then(($video) => {
      $video.muted = !$video.muted
      this.muted = $video.muted
    })
  }

  #pause() {
    return this.#togglePlayState(false)
  }

  async #togglePlayState(play = true) {
    const $video = await this.video
    play ? $video?.play() : $video?.pause()
  }

  #play() {
    return this.#togglePlayState(true)
  }

  getVideoPlayState(video) {
    return !!(
      video.currentTime > 0 &&
      !video.paused &&
      !video.ended &&
      video.readyState > 2
    )
  }

  async _attachHTMLVideoEvents() {
    const $video = await this.video
    if (!$video) return
    this.playing = this.getVideoPlayState($video)
    this.muted = $video.muted

    $video.addEventListener('pause', () => {
      this.playing = false
    })

    $video.addEventListener('play', () => {
      this.playing = true
    })

    $video.addEventListener('playing', () => {
      this.playing = true
    })
  }
}

customElements.define('inline-media', DeferredMedia)
